import { useCallback } from 'react';

export const useCreateRedirectUrlWithWizard = () =>
	useCallback((redirectUrl: string, taskId?: string) => {
		if (!redirectUrl) return '';

		const url = new URL(redirectUrl);
		const continueParam = url.searchParams.get('continue');
		if (continueParam) {
			const continueUrl = new URL(continueParam);
			continueUrl.searchParams.append('wizard', 'true');
			if (taskId) {
				continueUrl.searchParams.append('projectCreateTaskId', taskId);
			}
			url.searchParams.set('continue', continueUrl.toString());
		} else {
			url.searchParams.append('wizard', 'true');
			if (taskId) {
				url.searchParams.append('projectCreateTaskId', taskId);
			}
		}

		return url.toString();
	}, []);
